import isEqual from 'lodash/isEqual';

import type { DynamicRule, PageInstanceMapping } from 'clients/BrowserExtensionClient/BrowserExtension.types';

import {
  getDynamicRulesConfig,
  interceptRules,
  pageInstanceMapping,
} from 'clients/BrowserExtensionClient/browserExtension.config';
import { browserExtensionClient } from 'clients/BrowserExtensionClient/BrowserExtensionClient';

export const updateExtensionSettings = async () => {
  const [currentMapping, currentDynamicRules] = await Promise.all([
    browserExtensionClient.sendMessage<{ data: PageInstanceMapping | null }>('getPageInstanceMapping'),
    browserExtensionClient.sendMessage<{ data: DynamicRule[] | null }>('getDynamicRules'),
  ]);

  await browserExtensionClient.sendMessage('setInterceptRules', {
    interceptRules,
  });

  if (!isEqual(currentMapping.data, pageInstanceMapping)) {
    await browserExtensionClient.sendMessage('setPageInstanceMapping', pageInstanceMapping);
  }

  const userPlatform = getUserPlatform();
  const userBrands = getUserBrands();
  const dynamicRulesConfig = getDynamicRulesConfig(userPlatform, userBrands);

  if (!isEqual(currentDynamicRules.data, dynamicRulesConfig)) {
    await browserExtensionClient.sendMessage('setDynamicRules', dynamicRulesConfig);
  }
};

const getUserPlatform = () => {
  if (!navigator.userAgentData) {
    return '';
  }
  return navigator.userAgentData.platform || '';
};

const getUserBrands = () => {
  if (!navigator.userAgentData) {
    return '';
  }
  // Prevent duplicate "Not A(Brand"
  const userBrandsSet = new Set(
    navigator.userAgentData?.brands.map((brand) => `"${brand.brand}";v="${brand.version}"`),
  );
  userBrandsSet.add(`"Not A(Brand";v="8"`);

  return Array.from(userBrandsSet).join(', ');
};
